import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useIsGuestLikesEnabled() {
  const [isAuthenticated] = useCurrentUser();
  const { web_9275_guest_likes } = useExperiments(['web_9275_guest_likes']);

  return !isAuthenticated && web_9275_guest_likes === VARIANT_IDENTIFIER;
}
